import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Divider,
  Box,
} from "@mui/material";
import { ContactTypes } from "../../models/ContactTypes";

// Each section is its own nested Grid container.
// The heading row (xs={12}) is guaranteed to be alone before any field rows.

function SectionHeading({ title }) {
  return (
    <Box mb={1.5}>
      <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Divider />
    </Box>
  );
}

export default function ShippingTab({ formData, handleChange }) {
  return (
    <Box display="flex" flexDirection="column" gap={3}>

      {/* ── Address Section ──────────────────────────────────────────── */}
      <Box>
        <SectionHeading title="Address" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Company Name" name="shippingName"
              value={formData.shippingName || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Address" name="shippingAddress"
              value={formData.shippingAddress || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Address 2" name="shipAddress2"
              value={formData.shipAddress2 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="City" name="shippingCity"
              value={formData.shippingCity || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="State" name="shippingState"
              value={formData.shippingState || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Zip" name="shippingZip"
              value={formData.shippingZip || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Country" name="shippingCountry"
              value={formData.shippingCountry || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
        </Grid>
      </Box>

      {/* ── Contact Section ──────────────────────────────────────────── */}
      <Box>
        <SectionHeading title="Contact" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Phone 1 Type</InputLabel>
              <Select name="shippingPhone1Type"
                value={formData.shippingPhone1Type || ""}
                onChange={handleChange} label="Phone 1 Type">
                {Object.entries(ContactTypes).map(([key, { text, value }]) => (
                  <MenuItem key={key} value={value}>{text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Phone 1" name="shippingPhone1"
              value={formData.shippingPhone1 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Phone 2 Type</InputLabel>
              <Select name="shippingPhone2Type"
                value={formData.shippingPhone2Type || ""}
                onChange={handleChange} label="Phone 2 Type">
                {Object.entries(ContactTypes).map(([key, { text, value }]) => (
                  <MenuItem key={key} value={value}>{text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Phone 2" name="shippingPhone2"
              value={formData.shippingPhone2 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Contact Person" name="shippingContact"
              value={formData.shippingContact || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Email" name="shippingEmail"
              value={formData.shippingEmail || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Fax" name="shippingFax"
              value={formData.shippingFax || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
        </Grid>
      </Box>

    </Box>
  );
}